<template>
  <div class="popup-delete" @mousedown.self="$emit('close')">
    <div class="popup-content-delete">
      <div class="main-content">
        <h3><font-awesome-icon icon="times-circle" class="icon-delete"></font-awesome-icon>  Suppression </h3>

        <hr />
        <p>Êtes-vous sûr de vouloir supprimer l'article suivant :</p>
        <p style="text-align:center;font-weight:bold;font-size:26px;">{{titre}}</p>
        <br />
      </div>
      <div class="buttons-delete">
        <button class="btn-cancel" @click="$emit('close')">Annuler</button>
        <button class="btn-supp" @click="$emit('deleteArticle')">Supprimer</button>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'CmsDelete',
    props: {
      titre: String //titre passé en tant que string
    }
  };
</script>


<style>

  .main-content {
    width: 100%;
    height: 60%;
  }

  .buttons-delete {
    width: 100%;
    height: 40%;
    display: flex;
    justify-content: right;
  }

    .buttons-delete button {
      margin-right: 2%;
      width: 25%;
      font-size: 15px;
      color: white;
    }

  .btn-cancel {
    background: #c1c1c1;
  }

  .icon-delete {
    color: #ee3535;
  }

  .btn-cancel:hover {
    background: #a8a8a8;
  }

  .btn-supp {
    background: #f15e5e;
  }

    .btn-supp:hover {
      background: #ee3535;
    }

  .popup-delete {
    position: fixed;
    z-index: 999999;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(155, 155, 155, 0.8);
  }

    .popup-delete > .popup-content-delete {
      margin: 70px auto;
      padding: 20px;
      background: #fff;
      border-radius: 5px;
      width: 30%;
      max-height: 80%;
      position: relative;
    }
</style>



// WEBPACK FOOTER //
// src/components/Cms/CmsDeleteArticle.vue